export default "__VITE_ASSET__C5hY7xmA__"